export default __webpack_public_path__ + "static/media/rec2dmin.54aedf1a.jpg";